import { useId } from 'react';
import { Icon } from '../Icon';
import styles from './styles.module.scss';

interface Props {
  value: string;
  onChange: (text: string) => void;
  placeholder?: string;
}

export default function SearchBar({ value, onChange, placeholder = 'Buscar...' }: Props) {
  const id = useId();
  return (
    <div className={styles.searchBar}>
      <Icon name='search' />
      <input
        id={id}
        type='text'
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={styles.input}
      />
      {value ? (
        <div className={styles.closeWrapper} onClick={() => onChange('')}>
          <Icon name='close' />
        </div>
      ) : null}
    </div>
  );
}
